export type MediaType = "movie" | "drama" | "variety";

export type Region = "中国" | "韩国" | "日本" | "泰国" | "印度";

export interface Media {
  id: string;
  title: string;
  type: MediaType;
  region: Region;
  year: number;
  rating: number;
  duration: string;
  director: string;
  cast: string[];
  genres: string[];
  poster: string;
  synopsis: string;
  popularity: number;
  updatedAt: string;
  isNew: boolean;
  isHot: boolean;
  episodeInfo?: string;
}

export interface Special {
  id: string;
  title: string;
  subtitle: string;
  intro: string;
  cover: string;
  reason: string;
  mediaIds: string[];
}

export interface HeroSlide {
  id: string;
  mediaId: string;
  title: string;
  tagline: string;
  badge: string;
  image: string;
}

export const typeLabels: Record<MediaType, string> = {
  movie: "电影",
  drama: "电视剧",
  variety: "综艺",
};

export const mediaList: Media[] = [
  {
    id: "m01",
    title: "长夜将明",
    type: "movie",
    region: "中国",
    year: 2024,
    rating: 8.6,
    duration: "128分钟",
    director: "顾清和",
    cast: ["林知远", "苏眠", "周牧云"],
    genres: ["剧情", "悬疑"],
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%2C%20a%20lone%20figure%20standing%20at%20the%20edge%20of%20a%20vast%20dark%20plain%20as%20first%20light%20breaks%20on%20the%20horizon%2C%20dramatic%20moody%20lighting%2C%20deep%20blue%20and%20warm%20amber%20tones%2C%20high%20detail%20artistic%20composition%2C%20empty%20space%20at%20bottom%2C%20professional%20film%20poster%20style&width=500&height=750&seq=poster-m01&orientation=portrait",
    synopsis:
      "一场席卷北方小城的停电事故，让三个素不相识的人被困在同一条长夜里。他们各自背负着无法言说的秘密，在黑暗中彼此试探、靠近，最终在天亮前做出了改变一生的选择。",
    popularity: 9820,
    updatedAt: "2024-11-02",
    isNew: true,
    isHot: true,
  },
  {
    id: "m02",
    title: "山海遗梦",
    type: "movie",
    region: "中国",
    year: 2025,
    rating: 8.2,
    duration: "142分钟",
    director: "白景川",
    cast: ["陆青禾", "沈砚", "何清岚"],
    genres: ["奇幻", "冒险"],
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%2C%20misty%20ancient%20mountains%20and%20mythical%20sea%20creatures%20floating%20above%20clouds%2C%20ethereal%20fantasy%20atmosphere%2C%20jade%20green%20and%20gold%20tones%2C%20high%20detail%20artistic%20composition%2C%20empty%20space%20at%20bottom%2C%20professional%20film%20poster%20style&width=500&height=750&seq=poster-m02&orientation=portrait",
    synopsis:
      "少年阿舟在祖父留下的旧地图上发现了通往山海秘境的线索。当他踏入那片只存在于传说中的土地，才发现自己要守护的不只是一段遗落的梦境，还有整整一代人的记忆。",
    popularity: 8750,
    updatedAt: "2025-01-18",
    isNew: true,
    isHot: true,
  },
  {
    id: "m03",
    title: "霓虹之下",
    type: "movie",
    region: "日本",
    year: 2024,
    rating: 8.4,
    duration: "119分钟",
    director: "早川凉介",
    cast: ["高桥凑", "森川葵", "黑田诚一"],
    genres: ["犯罪", "剧情"],
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%2C%20rain-soaked%20Tokyo%20alley%20glowing%20with%20red%20neon%20signs%20and%20reflections%2C%20mysterious%20figure%20in%20shadow%2C%20noir%20crime%20mood%2C%20high%20detail%20artistic%20composition%2C%20empty%20space%20at%20bottom%2C%20professional%20film%20poster%20style&width=500&height=750&seq=poster-m03&orientation=portrait",
    synopsis:
      "东京新宿的深夜，一名代驾司机偶然捡到一部装满证据的手机。为了还清债务他决定敲诈失主，却一步步卷进这座城市最危险的地下交易网络。",
    popularity: 8210,
    updatedAt: "2024-09-27",
    isNew: false,
    isHot: true,
  },
  {
    id: "m04",
    title: "樱花七日",
    type: "movie",
    region: "日本",
    year: 2023,
    rating: 8.0,
    duration: "111分钟",
    director: "中村优纪",
    cast: ["佐藤遥", "木村悠人"],
    genres: ["爱情", "剧情"],
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%2C%20soft%20pink%20cherry%20blossoms%20drifting%20over%20a%20quiet%20riverside%20path%20at%20golden%20hour%2C%20gentle%20romantic%20atmosphere%2C%20pastel%20warm%20tones%2C%20high%20detail%20artistic%20composition%2C%20empty%20space%20at%20bottom%2C%20professional%20film%20poster%20style&width=500&height=750&seq=poster-m04&orientation=portrait",
    synopsis:
      "樱花开落的七天里，转学生美咲与沉默的书店少年约定，要在花瓣落尽之前完成一份未写完的清单。有些告白，注定只能藏在春天里。",
    popularity: 7640,
    updatedAt: "2023-04-12",
    isNew: false,
    isHot: false,
  },
  {
    id: "m05",
    title: "首尔雨夜",
    type: "movie",
    region: "韩国",
    year: 2024,
    rating: 8.5,
    duration: "126分钟",
    director: "朴志勋",
    cast: ["韩素英", "姜泰成", "李道允"],
    genres: ["悬疑", "犯罪"],
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%2C%20a%20solitary%20woman%20with%20umbrella%20on%20a%20wet%20Seoul%20street%20at%20night%2C%20cold%20blue%20rain%20and%20distant%20city%20lights%2C%20tense%20suspense%20mood%2C%20high%20detail%20artistic%20composition%2C%20empty%20space%20at%20bottom%2C%20professional%20film%20poster%20style&width=500&height=750&seq=poster-m05&orientation=portrait",
    synopsis:
      "一通来自十年前失踪妹妹的电话，把刑警车秀雅重新拉回那个雨夜。随着调查深入，她发现真相与自己的记忆并不一致。",
    popularity: 9120,
    updatedAt: "2024-10-15",
    isNew: true,
    isHot: true,
  },
  {
    id: "m06",
    title: "逆流的河",
    type: "movie",
    region: "韩国",
    year: 2023,
    rating: 8.1,
    duration: "134分钟",
    director: "金泰浩",
    cast: ["尹世雅", "朴俊昊"],
    genres: ["剧情", "家庭"],
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%2C%20a%20slow%20river%20winding%20through%20misty%20Korean%20countryside%20at%20dawn%2C%20lone%20boat%20and%20soft%20fog%2C%20melancholic%20contemplative%20mood%2C%20muted%20blue%20green%20tones%2C%20high%20detail%20artistic%20composition%2C%20empty%20space%20at%20bottom&width=500&height=750&seq=poster-m06&orientation=portrait",
    synopsis:
      "经营了三十年渡船的老船长决定在退休前走完最后一次逆流。船上坐着的是他多年未见的女儿，以及一段谁都不愿先提起的往事。",
    popularity: 6980,
    updatedAt: "2023-08-30",
    isNew: false,
    isHot: false,
  },
  {
    id: "m07",
    title: "湄南河水",
    type: "movie",
    region: "泰国",
    year: 2024,
    rating: 7.9,
    duration: "117分钟",
    director: "差猜·汶纳",
    cast: ["娜帕婉", "颂蓬"],
    genres: ["剧情", "文艺"],
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%2C%20golden%20temple%20spires%20beside%20the%20Chao%20Phraya%20river%20at%20sunset%2C%20warm%20orange%20sky%20and%20calm%20water%20reflections%2C%20serene%20exotic%20atmosphere%2C%20high%20detail%20artistic%20composition%2C%20empty%20space%20at%20bottom&width=500&height=750&seq=poster-m07&orientation=portrait",
    synopsis:
      "水上市场的船夫阿南在河水退去时发现了一只旧木箱。箱中的书信，牵出一段跨越两代人的河畔旧事。",
    popularity: 6420,
    updatedAt: "2024-06-21",
    isNew: false,
    isHot: false,
  },
  {
    id: "m08",
    title: "曼谷迷城",
    type: "movie",
    region: "泰国",
    year: 2025,
    rating: 8.3,
    duration: "122分钟",
    director: "素帕猜",
    cast: ["披拉蓬", "甘查娜"],
    genres: ["悬疑", "惊悚"],
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%2C%20crowded%20neon%20night%20market%20of%20Bangkok%20seen%20from%20above%2C%20tangled%20glowing%20lights%20and%20narrow%20alleys%2C%20mysterious%20urban%20energy%2C%20high%20detail%20artistic%20composition%2C%20empty%20space%20at%20bottom&width=500&height=750&seq=poster-m08&orientation=portrait",
    synopsis:
      "游客在曼谷夜市离奇失联，当地向导与一名外国记者循着摊位间留下的暗号，走进这座迷宫般的城市深处。",
    popularity: 7930,
    updatedAt: "2025-02-09",
    isNew: true,
    isHot: false,
  },
  {
    id: "m09",
    title: "恒河之光",
    type: "movie",
    region: "印度",
    year: 2023,
    rating: 8.0,
    duration: "139分钟",
    director: "拉杰什·库马尔",
    cast: ["阿米尔·汗", "普里亚"],
    genres: ["剧情", "音乐"],
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%2C%20glowing%20oil%20lamps%20floating%20on%20the%20Ganges%20river%20at%20dusk%2C%20warm%20saffron%20light%20and%20drifting%20smoke%2C%20spiritual%20emotional%20atmosphere%2C%20high%20detail%20artistic%20composition%2C%20empty%20space%20at%20bottom&width=500&height=750&seq=poster-m09&orientation=portrait",
    synopsis:
      "一位失意的古典乐手回到故乡圣城，在河岸边遇见一群靠卖艺为生的孩子。他决定用一整个雨季，陪他们完成一场不可能的演出。",
    popularity: 7210,
    updatedAt: "2023-11-11",
    isNew: false,
    isHot: false,
  },
  {
    id: "m10",
    title: "沉默的岛屿",
    type: "movie",
    region: "日本",
    year: 2025,
    rating: 8.7,
    duration: "130分钟",
    director: "小野寺凉",
    cast: ["石田彻", "绫濑真央"],
    genres: ["悬疑", "心理"],
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%2C%20a%20foggy%20isolated%20island%20with%20a%20single%20lighthouse%2C%20dark%20stormy%20sea%2C%20eerie%20unsettling%20mood%2C%20cold%20grey%20blue%20tones%2C%20high%20detail%20artistic%20composition%2C%20empty%20space%20at%20bottom&width=500&height=750&seq=poster-m10&orientation=portrait",
    synopsis:
      "灯塔守护人失踪后，调查员登上了这座只有二十户人家的孤岛。每个岛民都在说谎，而潮水每天都会抹去一切痕迹。",
    popularity: 9480,
    updatedAt: "2025-03-05",
    isNew: true,
    isHot: true,
  },
  {
    id: "d01",
    title: "长安夜雨",
    type: "drama",
    region: "中国",
    year: 2025,
    rating: 8.8,
    duration: "45分钟/集",
    director: "程砚秋",
    cast: ["裴之澜", "云舒", "陆沉"],
    genres: ["古装", "权谋"],
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20poster%2C%20ancient%20Chinese%20city%20walls%20under%20golden%20lanterns%20and%20falling%20rain%20at%20night%2C%20elegant%20historical%20atmosphere%2C%20warm%20amber%20and%20deep%20red%20tones%2C%20high%20detail%20artistic%20composition%2C%20empty%20space%20at%20bottom&width=500&height=750&seq=poster-d01&orientation=portrait",
    synopsis:
      "长安城的一场夜雨打乱了朝廷布下的整盘棋局。年轻的主簿顾淮在查案途中，逐渐触碰到十年前一桩宫廷旧案的核心。",
    popularity: 9950,
    updatedAt: "2025-03-20",
    isNew: true,
    isHot: true,
    episodeInfo: "全40集",
  },
  {
    id: "d02",
    title: "汉江往事",
    type: "drama",
    region: "韩国",
    year: 2024,
    rating: 8.5,
    duration: "50分钟/集",
    director: "郑宇成",
    cast: ["金惠秀", "李准基", "徐睿知"],
    genres: ["年代", "剧情"],
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20poster%2C%20nostalgic%20Seoul%20riverside%20in%20the%201980s%2C%20old%20bicycles%20and%20warm%20hazy%20afternoon%20light%2C%20retro%20nostalgic%20mood%2C%20high%20detail%20artistic%20composition%2C%20empty%20space%20at%20bottom&width=500&height=750&seq=poster-d02&orientation=portrait",
    synopsis:
      "从汉江边的一间小裁缝铺开始，两代人在三十年的时代变迁里，守住了一针一线，也守住了一个家。",
    popularity: 8890,
    updatedAt: "2024-12-01",
    isNew: false,
    isHot: true,
    episodeInfo: "全32集",
  },
  {
    id: "d03",
    title: "东京四季",
    type: "drama",
    region: "日本",
    year: 2024,
    rating: 8.3,
    duration: "42分钟/集",
    director: "渡边淳",
    cast: ["新垣悠真", "井上真理", "铃木隼"],
    genres: ["治愈", "生活"],
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20poster%2C%20a%20quiet%20Tokyo%20residential%20street%20changing%20through%20four%20seasons%2C%20cherry%20blossom%20then%20snow%2C%20gentle%20poetic%20mood%2C%20high%20detail%20artistic%20composition%2C%20empty%20space%20at%20bottom&width=500&height=750&seq=poster-d03&orientation=portrait",
    synopsis:
      "在一间不起眼的社区食堂里，四季流转，来去的客人带来了属于自己的故事，也悄悄治愈着店主失去的时光。",
    popularity: 8120,
    updatedAt: "2024-05-14",
    isNew: false,
    isHot: false,
    episodeInfo: "全24集",
  },
  {
    id: "d04",
    title: "江南烟雨录",
    type: "drama",
    region: "中国",
    year: 2023,
    rating: 8.6,
    duration: "46分钟/集",
    director: "沈书白",
    cast: ["顾南音", "江屿", "温以宁"],
    genres: ["古装", "爱情"],
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20poster%2C%20misty%20Jiangnan%20water%20town%20with%20arched%20stone%20bridges%20and%20willow%20trees%20in%20drizzle%2C%20classical%20elegant%20mood%2C%20soft%20green%20grey%20tones%2C%20high%20detail%20artistic%20composition%2C%20empty%20space%20at%20bottom&width=500&height=750&seq=poster-d04&orientation=portrait",
    synopsis:
      "烟雨江南的渡口，一位女画师与过路的书生因一幅未完成的画卷相识。乱世将至，他们约定用一幅画留住整个春天。",
    popularity: 8560,
    updatedAt: "2023-09-08",
    isNew: false,
    isHot: true,
    episodeInfo: "全36集",
  },
  {
    id: "d05",
    title: "半岛谍影",
    type: "drama",
    region: "韩国",
    year: 2025,
    rating: 8.4,
    duration: "55分钟/集",
    director: "崔东勋",
    cast: ["玄彬", "孙艺珍", "赵震雄"],
    genres: ["谍战", "悬疑"],
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20poster%2C%20shadowy%20figures%20exchanging%20documents%20in%20a%20dim%20parking%20garage%2C%20tense%20espionage%20mood%2C%20cold%20teal%20and%20steel%20tones%2C%20high%20detail%20artistic%20composition%2C%20empty%20space%20at%20bottom&width=500&height=750&seq=poster-d05&orientation=portrait",
    synopsis:
      "一份失窃的名单让南北情报网同时陷入混乱。潜伏多年的双面间谍必须在暴露前，选择自己真正的立场。",
    popularity: 9680,
    updatedAt: "2025-04-02",
    isNew: true,
    isHot: true,
    episodeInfo: "全20集",
  },
  {
    id: "d06",
    title: "京都花信",
    type: "drama",
    region: "日本",
    year: 2023,
    rating: 8.2,
    duration: "44分钟/集",
    director: "森山直太",
    cast: ["苍井优子", "山崎贤人"],
    genres: ["爱情", "文艺"],
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20poster%2C%20a%20traditional%20Kyoto%20garden%20in%20spring%20with%20falling%20petals%20and%20wooden%20temple%2C%20tranquil%20refined%20mood%2C%20soft%20pink%20and%20green%20tones%2C%20high%20detail%20artistic%20composition%2C%20empty%20space%20at%20bottom&width=500&height=750&seq=poster-d06&orientation=portrait",
    synopsis:
      "经营百年花道世家的长女，在守住家业与追寻自我之间摇摆。花信风起，她终于鼓起勇气剪下第一枝。",
    popularity: 7340,
    updatedAt: "2023-04-20",
    isNew: false,
    isHot: false,
    episodeInfo: "全16集",
  },
  {
    id: "d07",
    title: "曼谷恋人",
    type: "drama",
    region: "泰国",
    year: 2024,
    rating: 8.1,
    duration: "45分钟/集",
    director: "纳塔蓬",
    cast: ["马克", "皮姆"],
    genres: ["爱情", "都市"],
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20poster%2C%20a%20young%20couple%20on%20a%20rooftop%20above%20glowing%20Bangkok%20skyline%20at%20twilight%2C%20romantic%20city%20lights%2C%20warm%20purple%20orange%20tones%2C%20high%20detail%20artistic%20composition%2C%20empty%20space%20at%20bottom&width=500&height=750&seq=poster-d07&orientation=portrait",
    synopsis:
      "一个送外卖的少年和一个直播歌手，在曼谷的同一栋旧公寓里，因一封送错的信而相识。",
    popularity: 7020,
    updatedAt: "2024-07-19",
    isNew: false,
    isHot: false,
    episodeInfo: "全18集",
  },
  {
    id: "d08",
    title: "都市浮生记",
    type: "drama",
    region: "中国",
    year: 2024,
    rating: 8.0,
    duration: "43分钟/集",
    director: "许岸",
    cast: ["程夏", "方屿", "陈默"],
    genres: ["都市", "职场"],
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20poster%2C%20busy%20modern%20Shanghai%20street%20at%20rush%20hour%20with%20motion-blurred%20crowds%2C%20urban%20lonely%20mood%2C%20cool%20blue%20grey%20tones%2C%20high%20detail%20artistic%20composition%2C%20empty%20space%20at%20bottom&width=500&height=750&seq=poster-d08&orientation=portrait",
    synopsis:
      "四个合租在老公寓的年轻人，在快节奏的都市里互相取暖。生活很难，但他们把每一个普通的日子都过成了故事。",
    popularity: 7780,
    updatedAt: "2024-10-28",
    isNew: true,
    isHot: false,
    episodeInfo: "全30集",
  },
  {
    id: "d09",
    title: "济州岛的夏天",
    type: "drama",
    region: "韩国",
    year: 2023,
    rating: 8.3,
    duration: "48分钟/集",
    director: "吴世勋",
    cast: ["裴秀智", "南柱赫"],
    genres: ["治愈", "青春"],
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20poster%2C%20sunlit%20Jeju%20island%20coastline%20with%20green%20fields%20and%20blue%20sea%2C%20bright%20cheerful%20summer%20mood%2C%20fresh%20natural%20tones%2C%20high%20detail%20artistic%20composition%2C%20empty%20space%20at%20bottom&width=500&height=750&seq=poster-d09&orientation=portrait",
    synopsis:
      "一个被城市压得喘不过气的女孩，回到济州岛外婆留下的柑橘园。这个夏天，她重新学会了如何好好生活。",
    popularity: 7560,
    updatedAt: "2023-07-15",
    isNew: false,
    isHot: false,
    episodeInfo: "全16集",
  },
  {
    id: "d10",
    title: "孟买厨房",
    type: "drama",
    region: "印度",
    year: 2024,
    rating: 8.2,
    duration: "47分钟/集",
    director: "卡兰·梅塔",
    cast: ["迪娅", "阿俊"],
    genres: ["家庭", "美食"],
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20poster%2C%20a%20warm%20bustling%20Indian%20kitchen%20full%20of%20colorful%20spices%20and%20steam%2C%20joyful%20family%20atmosphere%2C%20rich%20warm%20tones%2C%20high%20detail%20artistic%20composition%2C%20empty%20space%20at%20bottom&width=500&height=750&seq=poster-d10&orientation=portrait",
    synopsis:
      "孟买老城区的一家小餐馆，祖孙三代为了守住祖父的招牌咖喱秘方，也为了守住这个家，展开了一场温暖又热闹的保卫战。",
    popularity: 6880,
    updatedAt: "2024-08-22",
    isNew: false,
    isHot: false,
    episodeInfo: "全22集",
  },
  {
    id: "v01",
    title: "亚洲厨房大挑战",
    type: "variety",
    region: "中国",
    year: 2025,
    rating: 8.4,
    duration: "80分钟/期",
    director: "综艺制作组",
    cast: ["张裕", "李恩琪", "黄子豪"],
    genres: ["美食", "竞技"],
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20poster%2C%20three%20chefs%20cooking%20dramatically%20with%20flying%20flames%20and%20colorful%20ingredients%2C%20energetic%20competition%20mood%2C%20vivid%20warm%20tones%2C%20high%20detail%20artistic%20composition%2C%20empty%20space%20at%20bottom&width=500&height=750&seq=poster-v01&orientation=portrait",
    synopsis:
      "来自亚洲各地的十二位主厨同台竞技，每一期用一道家乡菜讲述一个故事，用味道决出真正的亚洲之味。",
    popularity: 8940,
    updatedAt: "2025-03-28",
    isNew: true,
    isHot: true,
    episodeInfo: "更新至第8期",
  },
  {
    id: "v02",
    title: "星光练习生",
    type: "variety",
    region: "韩国",
    year: 2024,
    rating: 8.0,
    duration: "90分钟/期",
    director: "综艺制作组",
    cast: ["金智勋", "朴敏儿", "崔秀彬"],
    genres: ["选秀", "音乐"],
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20poster%2C%20young%20performers%20on%20a%20glowing%20stage%20under%20colorful%20spotlights%2C%20energetic%20youthful%20mood%2C%20bright%20neon%20tones%2C%20high%20detail%20artistic%20composition%2C%20empty%20space%20at%20bottom&width=500&height=750&seq=poster-v02&orientation=portrait",
    synopsis:
      "一百位怀揣舞台梦想的年轻人，在严苛的训练与公演中彼此竞争又相互扶持，只为争取那一个出道名额。",
    popularity: 8420,
    updatedAt: "2024-11-16",
    isNew: false,
    isHot: true,
    episodeInfo: "全14期",
  },
  {
    id: "v03",
    title: "旅行者的秘密地图",
    type: "variety",
    region: "日本",
    year: 2024,
    rating: 8.6,
    duration: "70分钟/期",
    director: "综艺制作组",
    cast: ["渡边翔", "宫本彩"],
    genres: ["旅行", "纪实"],
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20poster%2C%20an%20open%20vintage%20map%20and%20camera%20on%20a%20wooden%20table%20with%20distant%20mountains%2C%20adventurous%20travel%20mood%2C%20warm%20earthy%20tones%2C%20high%20detail%20artistic%20composition%2C%20empty%20space%20at%20bottom&width=500&height=750&seq=poster-v03&orientation=portrait",
    synopsis:
      "两位主持人带着一张没有标注终点的旧地图出发，走访亚洲最隐秘的小镇与村落，寻找地图上早已被遗忘的坐标。",
    popularity: 7860,
    updatedAt: "2024-09-10",
    isNew: false,
    isHot: false,
    episodeInfo: "全12期",
  },
  {
    id: "v04",
    title: "声音的战场",
    type: "variety",
    region: "中国",
    year: 2025,
    rating: 8.5,
    duration: "85分钟/期",
    director: "综艺制作组",
    cast: ["林启", "苏曼", "郑野"],
    genres: ["音乐", "竞演"],
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20poster%2C%20a%20singer%20silhouetted%20against%20dramatic%20stage%20lights%20and%20sound%20waves%2C%20powerful%20musical%20mood%2C%20deep%20blue%20and%20gold%20tones%2C%20high%20detail%20artistic%20composition%2C%20empty%20space%20at%20bottom&width=500&height=750&seq=poster-v04&orientation=portrait",
    synopsis:
      "实力唱将同台竞演，每期以不同的音乐主题重新演绎经典之作，用声音一决高下。",
    popularity: 9080,
    updatedAt: "2025-04-11",
    isNew: true,
    isHot: true,
    episodeInfo: "更新至第6期",
  },
  {
    id: "v05",
    title: "搞笑大联盟",
    type: "variety",
    region: "韩国",
    year: 2023,
    rating: 7.8,
    duration: "75分钟/期",
    director: "综艺制作组",
    cast: ["刘在石", "李光洙", "宋智孝"],
    genres: ["喜剧", "游戏"],
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20poster%2C%20playful%20colorful%20abstract%20shapes%20and%20confetti%20bursting%20on%20a%20bright%20stage%2C%20fun%20energetic%20comedy%20mood%2C%20vivid%20rainbow%20tones%2C%20high%20detail%20artistic%20composition%2C%20empty%20space%20at%20bottom&width=500&height=750&seq=poster-v05&orientation=portrait",
    synopsis:
      "一群喜剧人组成联盟，用一场场爆笑游戏与即兴表演，为观众带来最纯粹的快乐。",
    popularity: 6640,
    updatedAt: "2023-06-18",
    isNew: false,
    isHot: false,
    episodeInfo: "全20期",
  },
  {
    id: "v06",
    title: "极限冒险王",
    type: "variety",
    region: "印度",
    year: 2024,
    rating: 8.1,
    duration: "78分钟/期",
    director: "综艺制作组",
    cast: ["维克拉姆", "阿妮卡"],
    genres: ["冒险", "挑战"],
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20poster%2C%20a%20climber%20on%20a%20dramatic%20mountain%20cliff%20above%20clouds%20at%20sunrise%2C%20epic%20adventurous%20mood%2C%20orange%20and%20blue%20tones%2C%20high%20detail%20artistic%20composition%2C%20empty%20space%20at%20bottom&width=500&height=750&seq=poster-v06&orientation=portrait",
    synopsis:
      "素人挑战者踏上亚洲最险峻的自然赛道，用勇气与智慧完成一项项看似不可能的任务。",
    popularity: 7260,
    updatedAt: "2024-05-30",
    isNew: false,
    isHot: false,
    episodeInfo: "全10期",
  },
  {
    id: "v07",
    title: "恋爱观察室",
    type: "variety",
    region: "中国",
    year: 2025,
    rating: 8.2,
    duration: "88分钟/期",
    director: "综艺制作组",
    cast: ["何晓", "张瑞", "苏晴"],
    genres: ["情感", "观察"],
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20poster%2C%20cozy%20modern%20studio%20with%20warm%20lamps%20and%20heart-shaped%20soft%20lights%2C%20romantic%20observation%20mood%2C%20soft%20pink%20warm%20tones%2C%20high%20detail%20artistic%20composition%2C%20empty%20space%20at%20bottom&width=500&height=750&seq=poster-v07&orientation=portrait",
    synopsis:
      "一群性格各异的年轻人在同一屋檐下生活，观察室嘉宾全程围观并解读他们的心动瞬间。",
    popularity: 8620,
    updatedAt: "2025-03-16",
    isNew: true,
    isHot: false,
    episodeInfo: "更新至第9期",
  },
];

export const specials: Special[] = [
  {
    id: "sp01",
    title: "日韩经典电影重温计划",
    subtitle: "那些值得再看一遍的亚洲光影",
    intro:
      "从东京的雨夜到首尔的江畔，日韩电影用克制而细腻的镜头语言，讲述着关于人性、记忆与爱的故事。本期专题精选多部口碑之作，带你重温亚洲电影最动人的瞬间。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20banner%2C%20classic%20Japanese%20and%20Korean%20cinema%20tribute%20with%20vintage%20film%20reels%20mountains%20and%20cherry%20blossoms%2C%20nostalgic%20retro%20tones%2C%20artistic%2C%20high%20detail&width=1200&height=600&seq=special-sp01&orientation=landscape",
    reason:
      "这些作品兼具艺术水准与观赏性，是理解日韩电影美学的最佳入口，适合静下心来慢慢品味。",
    mediaIds: ["m03", "m04", "m05", "m06", "m10", "d03"],
  },
  {
    id: "sp02",
    title: "高能悬疑追剧清单",
    subtitle: "一口气看完停不下来的烧脑之作",
    intro:
      "真相往往藏在你没注意到的细节里。本期专题汇集悬疑、犯罪与谍战题材的佳作，反转不断、悬念迭起，专治剧荒，慎入更衣室。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20banner%2C%20Asian%20suspense%20thriller%20tribute%20with%20dark%20alley%20fog%20and%20glowing%20clues%2C%20tense%20moody%20blue%20tones%2C%20artistic%2C%20high%20detail&width=1200&height=600&seq=special-sp02&orientation=landscape",
    reason:
      "节奏紧凑、信息密度高，适合喜欢动脑的观众，每一集都值得回看细节。",
    mediaIds: ["m05", "m08", "m10", "d05", "m01", "m03"],
  },
  {
    id: "sp03",
    title: "治愈系亚洲家庭剧",
    subtitle: "人间烟火里的温柔力量",
    intro:
      "生活的答案，常常藏在厨房的烟火气和家人的唠叨里。本期专题带你走进这些温暖治愈的家庭故事，在忙碌之余找回被爱包围的松弛感。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20banner%2C%20heartwarming%20Asian%20family%20drama%20tribute%20with%20warm%20home%20kitchen%20light%2C%20cozy%20emotional%20tones%2C%20artistic%2C%20high%20detail&width=1200&height=600&seq=special-sp03&orientation=landscape",
    reason:
      "没有激烈的冲突，只有细水长流的陪伴，适合下班后放松身心，慢慢感受生活本来的样子。",
    mediaIds: ["d09", "d10", "d03", "m06", "d02", "v03"],
  },
];

export const heroSlides: HeroSlide[] = [
  {
    id: "h1",
    mediaId: "m10",
    title: "沉默的岛屿",
    tagline: "孤岛上的二十户人家，每个人都在说谎",
    badge: "独家推荐",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20banner%2C%20epic%20Asian%20film%20scene%20with%20dramatic%20mountain%20landscape%20and%20glowing%20sunrise%2C%20film%20reel%20atmosphere%2C%20deep%20blue%20and%20warm%20gold%20tones%2C%20high%20detail%2C%20artistic%2C%20empty%20space%20for%20text%20on%20the%20left%20side&width=1600&height=900&seq=hero-h1&orientation=landscape",
  },
  {
    id: "h2",
    mediaId: "d05",
    title: "半岛谍影",
    tagline: "一份失窃的名单，让两个阵营同时乱了阵脚",
    badge: "热播剧集",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20banner%2C%20neon-lit%20rainy%20Asian%20city%20street%20at%20night%20with%20reflections%2C%20moody%20thriller%20atmosphere%2C%20deep%20blue%20and%20red%20neon%20tones%2C%20high%20detail%2C%20artistic%2C%20empty%20space%20for%20text%20on%20the%20left%20side&width=1600&height=900&seq=hero-h2&orientation=landscape",
  },
  {
    id: "h3",
    mediaId: "d01",
    title: "长安夜雨",
    tagline: "一场夜雨，打乱了朝廷布下的整盘棋",
    badge: "古装大剧",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20banner%2C%20elegant%20ancient%20Asian%20palace%20hall%20with%20red%20lanterns%20and%20golden%20light%2C%20historical%20drama%20atmosphere%2C%20warm%20rich%20tones%2C%20high%20detail%2C%20artistic%2C%20empty%20space%20for%20text%20on%20the%20left%20side&width=1600&height=900&seq=hero-h3&orientation=landscape",
  },
  {
    id: "h4",
    mediaId: "m04",
    title: "樱花七日",
    tagline: "有些告白，注定只能藏在春天里",
    badge: "文艺爱情",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20banner%2C%20romantic%20cherry%20blossom%20park%20at%20golden%20hour%20with%20soft%20bokeh%2C%20gentle%20warm%20pastel%20tones%2C%20high%20detail%2C%20artistic%2C%20empty%20space%20for%20text%20on%20the%20left%20side&width=1600&height=900&seq=hero-h4&orientation=landscape",
  },
  {
    id: "h5",
    mediaId: "v01",
    title: "亚洲厨房大挑战",
    tagline: "用味道，决出真正的亚洲之味",
    badge: "热播综艺",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20banner%2C%20colorful%20energetic%20TV%20variety%20show%20stage%20with%20spotlights%20and%20confetti%2C%20fun%20vibrant%20atmosphere%2C%20high%20detail%2C%20artistic%2C%20empty%20space%20for%20text%20on%20the%20left%20side&width=1600&height=900&seq=hero-h5&orientation=landscape",
  },
];

export const regions: Region[] = ["中国", "韩国", "日本", "泰国", "印度"];

export const years: number[] = [2025, 2024, 2023];